import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL, PHONE, PHONE_TEL } from "../data";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/services", label: "Services", testid: "nav-services-link" },
  { to: "/gallery", label: "Gallery", testid: "nav-gallery-link" },
  { to: "/holiday", label: "Holiday Lighting", testid: "nav-holiday-link" },
  { to: "/about", label: "About Us", testid: "nav-about-link" },
  { to: "/reviews", label: "Reviews", testid: "nav-reviews-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 bg-[#150A21]/80 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center group" onClick={() => setOpen(false)}>
          <img
            src={LOGO_URL}
            alt="GlowMode Lighting"
            className="h-10 sm:h-11 w-44 sm:w-52 object-cover object-center mix-blend-screen transition-transform duration-300 group-hover:scale-105"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors duration-300 ${
                  isActive ? "text-gold" : "text-slate-300 hover:text-gold-light"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a href={PHONE_TEL} data-testid="nav-phone-link" className="flex items-center gap-2 text-sm text-slate-300 hover:text-gold-light transition-colors duration-300">
            <Phone className="h-4 w-4 text-gold" />
            {PHONE}
          </a>
          <Link
            to="/book"
            data-testid="nav-book-now-button"
            className="px-5 py-2.5 rounded-full text-sm font-semibold text-obsidian bg-gradient-to-br from-gold-light via-gold to-gold-dark transition-all duration-300 hover:shadow-[0_0_25px_rgba(212,175,55,0.4)] hover:-translate-y-0.5"
          >
            Book Now
          </Link>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden text-slate-200 p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-white/5 bg-[#150A21]/95 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 text-base font-medium border-b border-white/5 ${
                    isActive || (l.to === "/" && location.pathname === "/") ? "text-gold" : "text-slate-300"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              data-testid="nav-book-now-button-mobile"
              onClick={() => setOpen(false)}
              className="mt-4 mb-2 text-center px-5 py-3 rounded-full text-sm font-semibold text-obsidian bg-gradient-to-br from-gold-light via-gold to-gold-dark"
            >
              Book Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
